import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { IProductSchemaPartial, IProductSchema } from '../../type/product';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';
import { IKeywordBrandSchema } from '../../type/keywordBrand';
import { IKeywordClassificationSchema } from '../../type/keywordClassification';


export interface IProductQuerySearchInfo {
  searchInfo: {
    classificationInfos: {
      key: string
      classification?: IKeywordClassificationSchema
      count: number
    }[]
    brandInfos: {
      key: string
      brand?: IKeywordBrandSchema
      count: number
    }[]
    groupByAlphabetInfo: {
      key: string
      count: number
    }[];
  };
}



export interface IProductVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  status?: boolean;
  featured?: boolean;
  names?: string[];
  companyId?: string;
  companyIds?: string[];
  origin?: string;
  slug?: string;
  isSearchable?: boolean;
  isDropshippedProduct?: boolean;
  isDropshippingEnable?: boolean;
  sourceDropshippedProductCompanyId?: string;
  subdirectoryTag?: {
    id: string,
    status: boolean
  }
  hasImage?: boolean;
  matchAnyKeywordClassificationIds?: string[];
  matchAllKeywordClassificationIds?: string[];
  matchAnyKeywordBrandIds?: string[];
  matchAllKeywordBrandIds?: string[];
  matchAnyKeywordTagIds?: string[];
  matchAllKeywordTagIds?: string[];

  random?: boolean;
}
 sort: {
  _id?: number;
  createdTime?: number;
  updatedTime?: number;
  ordering?: number;
  featured?: number;
  finalPrice?: number;
  inventoryStockInStock?: number;
  inventoryStockLeadTime?: number;
  categoryOrdering?: Record<string,number>
}
 search: {
  _id?: string;
  name?: string;
  nameStartWith?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  useSearch: boolean
  
 
}
export const ProductQueryTypeDefinitionKey = 'Product';
export type IProductVarsPartial = Partial<IProductVars>
export type IProductDataPartial = DeepPartial<IProductSchemaPartial>
export interface IProductQueryData<TData extends IProductSchema = IProductSchema>{
  

    products: IWithPagination<TData> & IProductQuerySearchInfo
}

export function productQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    products(
        $filter: ProductQueryFilterParameterInput,
$search: ProductQuerySearchParameterInput,
$sort: ProductQuerySortParameterInput,
$skip: Int,
$limit: Int,
$useSearch: Boolean
        ){
        

    products(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit,
useSearch: $useSearch
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useProductLazyQuery<TData extends IProductSchema>(
  fragment: string,
  options?: QueryHookOptions<IProductQueryData<TData>, IProductVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<IProductQueryData<TData>, IProductVarsPartial>(productQuery(fragment, rootFragment, withPagination), options);
}

export function useProductQuery<TData extends IProductSchema>(
  fragment: string,
  options?: QueryHookOptions<IProductQueryData<TData>, IProductVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<IProductQueryData<TData>, IProductVarsPartial>(productQuery(fragment, rootFragment, withPagination), options);
}
